"use client";
export const initState = {
  chatData: [],
  loading: false,
  assistantTyping: true,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "SET_CHAT_DATA":
      return {
        ...state,
        chatData:
          typeof action.payload === "function"
            ? action.payload(state.chatData)
            : [
                ...(state.chatData || []),
                ...(Array.isArray(action.payload)
                  ? action.payload
                  : [action.payload]),
              ],
      };
    case "SET_LOADING":
      return { ...state, loading: action.loading };

    // 👇 NEW
    case "SET_ASSISTANT_TYPING":
      return { ...state, assistantTyping: action.value };

    default:
      return state;
  }
};

export default reducer;
